import React, { Component } from 'react'
import PropTypes from 'prop-types'
import CheckIcon from '../../Common/components/svg/CheckIcon';
import SubmitButton from '../../Common/components/SubmitButton';
import './MyStableEmailUnsubscribe.scss'

class MyStableEmailUnsubscribe extends Component {

    static propTypes = {
        location: PropTypes.object.isRequired,
        unsubscribeAction: PropTypes.func.isRequired,
        redirectAction: PropTypes.func.isRequired,
        unsubscribeSuccess: PropTypes.bool
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        if (nextProps.unsubscribeSuccess === true) {
            return {...prevState, btnLabel: "Unsubscribed", btnDisabled: true}
        } else if (nextProps.unsubscribeSuccess === false) {
            return {...prevState, btnLabel: "Unsubscribe Failed", btnDisabled: true}
        } else {
            return {...prevState, btnLabel: "Unsubscribe", btnDisabled: false}
        }
    }

    state = {
        btnLabel: "Unsubscribe",
        btnDisabled: false
    }

    handleOnClick = (email, token) => {
        this.setState({
            btnDisabled: true,
        })
        this.props.unsubscribeAction(email, token)
    }

    parseQueryString = queryString => {
        let params = {}
        queryString.replace(/([^?=&]+)(=([^&]*))?/g, (match, $1, $2, $3) => params[$1] = $3)
        return params
    }

    render() {
        //if missing qs params redirect back to my stable index
        const {email, token} = this.parseQueryString(this.props.location.search)
        if (!email || !token) {
           this.props.redirectAction('/racing/my-stable')
        }
        return (
            <article>
                <header>
                    <h2 className="section-title my-stable-subtitle">Unsubscribe from My Stable emails</h2>
                    <p className="my-stable-selections-info">
                        Check the email address below and click Unsubscribe to stop receiving My Stable email notifications.
                    </p>
                </header>
                <section className="my-stable-unsubscribe-section">
                    <input className="my-stable-email-input" value={email} readOnly/>
                    <SubmitButton successResult={this.props.unsubscribeSuccess} label={this.state.btnLabel} disabled={this.state.btnDisabled} onClickAction={() => this.handleOnClick(email, token)}/>
                </section>
            </article>
        )
    }
}

export default MyStableEmailUnsubscribe



// WEBPACK FOOTER //
// ./modules/HorseRacing/components/MyStableEmailUnsubscribe.js